import React from "react";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/api";
import { StatusBadge } from "@/components/app/ui-bits";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectKpiCenter from "@/components/app/ProjectKpiCenter";
import { Clock, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function TimePanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/time-logs?project_id=${project.id}`, [project.id]);
  const totalHours = items.reduce((acc, r) => acc + (Number(r.hours) || 0), 0);
  return (
    <div data-testid={`panel-time-${project.id}`}>
      <PanelHeader icon={Clock} title="Time Logs"
        subtitle={`${items.length} entries · ${totalHours.toFixed(1)}h total`}
        action={<ProjectKpiCenter project={project} trigger={<Button size="sm" variant="outline">Approve <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No time logged against this project yet." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: `${r.hours || 0}h · ${r.activity || "Time log"}`, subtitle: `${r.staff_name || r.staff_id || ""} · ${r.work_date || ""}` })}
                data-testid={`time-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] text-slate-500 w-20">{r.work_date ? formatDate(r.work_date) : "—"}</span>
              <span className="font-mono-alt tabular-nums text-xs text-slate-700 w-12">{(Number(r.hours) || 0).toFixed(1)}h</span>
              <span className="min-w-0 flex-1 truncate">{r.activity || r.description || "Time entry"}</span>
              <span className="font-mono-alt text-[10px] text-slate-500">{r.staff_name || "—"}</span>
              <StatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
